const selectLang = {
 boxContainer: { 
    mx: 'auto', 
    bgcolor: 'white', 
    mt:'0 !important',
    padding: '1rem 1rem 0 1rem',
    width: {
      xs: '100%', 
      md: '560px', 
    },
 },
 dialogHeading: {
   fontSize: '18px', 
   fontWeight: 600, 
   color: '#111111', 
   lineHeight: '150%',
 },
 dialogSubHeading: {
   fontSize: '14px', 
   lineHeight: '150%', 
   color: '#6C6C6C',
   paddingBottom: '0.5rem'
 },
  proceedButton: (primaryColor) => ({
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '24px',
    padding: '12px 16px',
    borderRadius: '8px',
    width: {
      xs: '100%',
      md: 'auto',
    },
    backgroundColor: primaryColor,
    '&:focus': {
      backgroundColor: primaryColor,
    },
    '&:hover': {
      backgroundColor: primaryColor,
    },
  }),
 buttonContainer: {
    display: 'flex', 
    justifyContent: 'flex-end',
    padding: '1rem',
    borderTop: '1px solid #D9D9D9',
    justifyContent: {
      xs: 'center', 
      md: 'flex-end', 
    },
 },
 closeIcon: {
   cursor: 'pointer', 
   fontSize: '18px', 
   fontWeight: 600, 
   color: '#1C1B1F', 
   lineHeight: '150%',
 },
  selectLang: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    mr: 0,
    ml: 0,
    borderRadius: '8px',
    '& .MuiFormControlLabel-label': {
      fontSize: '1rem',
      fontWeight: 400,
      textAlign: 'left',
      pl: '0.5rem'
    },
  },
  radio: {
    color: '#d0d0d0',
  }

};
export default selectLang;
